import gql from 'graphql-tag';

export const GET_USER_BY_HASH = gql`
  query GetUserByHashQuery($input: GetUserByVerificationHashInput!) {
    getUserByVerificationHash(input: $input) {
      email
    }
  }
`;

export type GetUserByVerificationHashVariables = {
  input: {
    hash: string;
  };
};

export type GetUserByVerificationHashResponse = {
  getUserByVerificationHash: { email: string };
};
